import { CategoriesSetupValuesType } from './types';

export const MAX_USERNAME_LENGTH = 20;

export const AI_DATA = {
  furry: {
    circleIcons:
      'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/girl/icons.png',
    greet: {
      imageSrc:
        'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/furry/greet.png',
    },
    main: {
      imageSrc:
        'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/furry/main.png',
    },
    chat: {
      imageSrc:
        'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/furry/chat.png',
    },
    // TODO: Correct with image for noLimit and chatVibe
    noLimit: {
      bgImageSrc:
        'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/girl/bg-no-limit.png',
    },
    chatVibe: {
      bgImageSrc:
        'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/girl/bg-chat-vibe.png',
    },
    relationships: {
      imageSrc:
        'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/girl/relationships.png',
    },
    dressUp: {
      imageSrc:
        'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/furry/dress-up.png',
    },
    paywallV2: {
      mainImgSrc:
        'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/girl/paywall-v2-main.png',
    },
    paywallV3: {
      mainImgSrc:
        'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/furry/paywall-v3-main.png',
    },
    paywallHowItWorks: {
      stepOne: {
        bgImageSrc:
          'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/furry/how-works-bg-1.png',
      },
      stepThree: {
        bgImageSrc:
          'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/furry/how-works-bg-3.png',
      },
    },
    cards: [
      {
        title: 'Eva',
        subtitle: 'Your girlfriend is a bunny',
        imageSrc:
          'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/furry/card-1.png',
      },
      {
        title: 'Krystal',
        subtitle: 'Fictional Character',
        imageSrc:
          'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/furry/card-2.png',
      },
      {
        title: 'Meow meow',
        subtitle: 'Meow meow',
        imageSrc:
          'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/furry/card-3.png',
      },
    ],
    characteristics: [
      {
        label: 'Submissive',
        imageSrc:
          'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/ai-characteristic/furry/Submissive.png',
      },
      {
        label: 'Neutral',
        imageSrc:
          'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/ai-characteristic/furry/Neutral.png',
      },
      {
        label: 'Flirty',
        imageSrc:
          'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/ai-characteristic/furry/Flirty.png',
      },
      {
        label: 'Naughty',
        imageSrc:
          'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/ai-characteristic/furry/Naughty.png',
      },
      {
        label: 'Dominant',
        imageSrc:
          'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/ai-characteristic/furry/Dominant.png',
      },
    ],
  },
  girl: {
    circleIcons:
      'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/girl/icons.png',
    greet: {
      imageSrc:
        'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/girl/greet.png',
    },
    main: {
      imageSrc:
        'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/girl/main.png',
    },
    chat: {
      imageSrc:
        'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/girl/chat.png',
    },
    noLimit: {
      bgImageSrc:
        'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/girl/bg-no-limit.png',
    },
    chatVibe: {
      bgImageSrc:
        'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/girl/bg-chat-vibe.png',
    },
    relationships: {
      imageSrc:
        'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/girl/relationships.png',
    },
    dressUp: {
      imageSrc:
        'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/girl/dress-up.png',
    },
    paywallV2: {
      mainImgSrc:
        'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/girl/paywall-v2-main.png',
    },
    paywallV3: {
      mainImgSrc:
        'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/girl/paywall-v3-main.png',
    },
    paywallHowItWorks: {
      stepOne: {
        bgImageSrc:
          'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/girl/how-works-bg-1.png',
      },
      stepThree: {
        bgImageSrc:
          'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/girl/how-works-bg-3.png',
      },
    },
    cards: [
      {
        title: 'Amy',
        subtitle: 'Actress',
        imageSrc:
          'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/girl/card-1.png',
      },
      {
        title: 'Jane M',
        subtitle: 'Journalist',
        imageSrc:
          'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/girl/card-2.png',
      },
      {
        title: 'Lana',
        subtitle: '20 yo, songwriter',
        imageSrc:
          'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/girl/card-3.png',
      },
    ],
    characteristics: [
      {
        label: 'Submissive',
        imageSrc:
          'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/ai-characteristic/girl/Submissive.png',
      },
      {
        label: 'Neutral',
        imageSrc:
          'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/ai-characteristic/girl/Neutral.png',
      },
      {
        label: 'Flirty',
        imageSrc:
          'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/ai-characteristic/girl/Flirty.png',
      },
      {
        label: 'Naughty',
        imageSrc:
          'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/ai-characteristic/girl/Naughty.png',
      },
      {
        label: 'Dominant',
        imageSrc:
          'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/ai-characteristic/girl/Dominant.png',
      },
    ],
  },
  legs: {
    circleIcons:
      'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/legs/icons.png',
    greet: {
      imageSrc:
        'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/legs/greet.png',
    },
    main: {
      imageSrc:
        'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/legs/main.png',
    },
    chat: {
      imageSrc:
        'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/legs/chat.png',
    },
    noLimit: {
      bgImageSrc:
        'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/legs/bg-no-limit.png',
    },
    chatVibe: {
      bgImageSrc:
        'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/legs/bg-chat-vibe.png',
    },
    relationships: {
      imageSrc:
        'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/legs/relationships.png',
    },
    dressUp: {
      imageSrc:
        'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/legs/dress-up.png',
    },
    paywallV2: {
      mainImgSrc:
        'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/legs/paywall-v2-main.png',
    },
    paywallV3: {
      mainImgSrc:
        'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/legs/paywall-v3-main.png',
    },
    paywallHowItWorks: {
      stepOne: {
        bgImageSrc:
          'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/legs/how-works-bg-1.png',
      },
      stepThree: {
        bgImageSrc:
          'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/legs/how-works-bg-3.png',
      },
    },
    cards: [
      {
        title: 'Amy',
        subtitle: 'Actress',
        imageSrc:
          'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/girl/card-1.png',
      },
      {
        title: 'Jane M',
        subtitle: 'Journalist',
        imageSrc:
          'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/girl/card-2.png',
      },
      {
        title: 'Lana',
        subtitle: '20 yo, songwriter',
        imageSrc:
          'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/girl/card-3.png',
      },
    ],
    characteristics: [
      {
        label: 'Submissive',
        imageSrc:
          'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/ai-characteristic/girl/Submissive.png',
      },
      {
        label: 'Neutral',
        imageSrc:
          'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/ai-characteristic/girl/Neutral.png',
      },
      {
        label: 'Flirty',
        imageSrc:
          'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/ai-characteristic/girl/Flirty.png',
      },
      {
        label: 'Naughty',
        imageSrc:
          'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/ai-characteristic/girl/Naughty.png',
      },
      {
        label: 'Dominant',
        imageSrc:
          'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/ai-characteristic/girl/Dominant.png',
      },
    ],
  },
  gay: {
    circleIcons:
      'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/gay/icons.png',
    greet: {
      imageSrc:
        'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/gay/greet.png',
    },
    main: {
      imageSrc:
        'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/gay/main.png',
    },
    chat: {
      imageSrc:
        'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/gay/chat.png',
    },
    // TODO: Correct with image for noLimit and chatVibe
    noLimit: {
      bgImageSrc:
        'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/girl/bg-no-limit.png',
    },
    chatVibe: {
      bgImageSrc:
        'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/girl/bg-chat-vibe.png',
    },
    // TODO: Correct with image for gay relationships
    relationships: {
      imageSrc:
        'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/girl/relationships.png',
    },
    dressUp: {
      imageSrc:
        'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/gay/dress-up.png',
    },
    paywallV2: {
      mainImgSrc:
        'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/girl/paywall-v2-main.png',
    },
    paywallV3: {
      mainImgSrc:
        'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/girl/paywall-v3-main.png',
    },
    paywallHowItWorks: {
      stepOne: {
        bgImageSrc:
          'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/girl/how-works-bg-1.png',
      },
      stepThree: {
        bgImageSrc:
          'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/girl/how-works-bg-3.png',
      },
    },
    cards: [
      {
        title: 'MiF',
        subtitle: 'Trust Fund, 6’5, blue eyes',
        imageSrc:
          'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/gay/card-1.png',
      },
      {
        title: 'Jan',
        subtitle: 'Korean-American, 25, box',
        imageSrc:
          'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/gay/card-2.png',
      },
      {
        title: 'Tom',
        subtitle: 'Best friend',
        imageSrc:
          'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/gay/card-3.png',
      },
    ],
    characteristics: [
      {
        label: 'Submissive',
        imageSrc:
          'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/ai-characteristic/gay/Submissive.png',
      },
      {
        label: 'Neutral',
        imageSrc:
          'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/ai-characteristic/gay/Neutral.png',
      },
      {
        label: 'Flirty',
        imageSrc:
          'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/ai-characteristic/gay/Flirty.png',
      },
      {
        label: 'Naughty',
        imageSrc:
          'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/ai-characteristic/gay/Naughty.png',
      },
      {
        label: 'Dominant',
        imageSrc:
          'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/ai-characteristic/gay/Dominant.png',
      },
    ],
  },
  old_women: {
    circleIcons:
      'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/old_women/icons.png',
    greet: {
      imageSrc:
        'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/old_women/greet.png',
    },
    main: {
      imageSrc:
        'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/old_women/main.png',
    },
    chat: {
      imageSrc:
        'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/old_women/chat.png',
    },
    noLimit: {
      bgImageSrc:
        'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/old_women/bg-no-limit.png',
    },
    chatVibe: {
      bgImageSrc:
        'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/old_women/bg-chat-vibe.png',
    },
    relationships: {
      imageSrc:
        'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/old_women/relationships.png',
    },
    dressUp: {
      imageSrc:
        'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/old_women/dress-up.png',
    },
    paywallV2: {
      mainImgSrc:
        'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/old_women/paywall-v2-main.png',
    },
    paywallV3: {
      mainImgSrc:
        'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/old_women/paywall-v3-main.png',
    },
    paywallHowItWorks: {
      stepOne: {
        bgImageSrc:
          'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/old_women/how-works-bg-1.png',
      },
      stepThree: {
        bgImageSrc:
          'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/old_women/how-works-bg-3.png',
      },
    },
    cards: [
      {
        title: 'May Lee',
        subtitle: 'Chinese old lady',
        imageSrc:
          'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/old_women/card-1.png',
      },
      {
        title: 'Martha Schneider',
        subtitle: 'Your friend`s mother',
        imageSrc:
          'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/old_women/card-2.png',
      },
      {
        title: 'Nana Nora',
        subtitle: 'from New Orlean’s',
        imageSrc:
          'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/old_women/card-3.png',
      },
    ],
    characteristics: [
      {
        label: 'Submissive',
        imageSrc:
          'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/ai-characteristic/old_women/Submissive.png',
      },
      {
        label: 'Neutral',
        imageSrc:
          'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/ai-characteristic/old_women/Neutral.png',
      },
      {
        label: 'Flirty',
        imageSrc:
          'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/ai-characteristic/old_women/Flirty.png',
      },
      {
        label: 'Naughty',
        imageSrc:
          'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/ai-characteristic/old_women/Naughty.png',
      },
      {
        label: 'Dominant',
        imageSrc:
          'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/ai-characteristic/old_women/Dominant.png',
      },
    ],
  },
};

export const CATEGORIES_SETUP: Record<string, CategoriesSetupValuesType> = {
  'eb275d5e-4188-431e-a5cd-1375709f90ae': {
    title: 'Feet',
    number: 1224,
    priority: 1,
    key: 'feet',
  },
  'd4dddbb7-78b1-4704-b5d8-c51eebf92d01': {
    title: 'Girls',
    number: 14952,
    priority: 100,
    key: 'girl',
  },
  '92d648fa-6f0d-4282-80d5-045f363d1685': {
    title: 'Older women',
    number: 12753,
    priority: 80,
    key: 'old_women',
  },
  '93616998-7312-445c-bebc-b06cce7844f1': {
    title: 'Roleplay',
    number: 1391,
    priority: 1,
    key: 'roleplay',
  },
  'cfd50255-6f15-4060-b9ba-2ee4f3cb5a7e': {
    title: 'BBW',
    number: 3570,
    priority: 60,
    key: 'bbw',
  },
  '51be5603-b2c1-4848-a9ca-fdc9b6c72872': {
    title: 'Strong & Stunning',
    number: 5839,
    priority: 40,
    key: 'strong_stunning',
  },
  'b85cb582-6a0f-492e-bb05-a17d69d61c38': {
    title: 'On the duty',
    number: 3446,
    priority: 1,
    key: 'on_the_duty',
  },
  '7ffe5dd5-3a4b-42b8-9817-62fce9ab152e': {
    title: 'Real people AIs',
    number: 1417,
    priority: 1,
    key: 'real_people_ais',
  },
  '9ae39135-79f9-4b1f-ab33-fa91f5fd54b8': {
    title: 'Furry',
    number: 1811,
    priority: 1,
    key: 'furry',
  },
  'e336e63f-beac-4d2d-b11b-4bbb547ed5e8': {
    title: 'Anime',
    number: 8385,
    priority: 1,
    key: 'anime',
  },
  '1d7a79ea-1f81-47c1-ad1c-8eed3bd08378': {
    title: 'Boys',
    number: 1155,
    priority: 1,
    key: 'boy',
  },
};
